"use strict"

import Social from "./Social";

class Filiale {
    constructor() {
        this.breakpoint = 790;
    }

    init() {
        const videos = document.querySelectorAll('.filiale-video-container');
        const quotesCanvas = document.querySelectorAll('.filiale-quote-photo canvas');
        const socialWalls = document.querySelectorAll('.filiale-social');

        if (videos) {
            videos.forEach((element) => {
                element.addEventListener('click', (e) => this.toggleVideo(e))
            });
        }

        if (quotesCanvas) {
            quotesCanvas.forEach((canvas) => this.initCanvas(canvas));
        }

        if (socialWalls) {
            socialWalls.forEach((socialWall) => {
                const social = new Social();
                social.init(socialWall);
            })
        }
        window.addEventListener('resize', () => {quotesCanvas.forEach((canvas) => this.initCanvas(canvas));})
    }

    toggleVideo(e) {
        const video = e.currentTarget;
        const state = video.dataset.state;

        if (state === "play") {
            e.preventDefault();
            this.changeVideoState(video, 'pause');
        } else if (state === "pause") {
            this.changeVideoState(video, 'play');  
        } else if (state === "init") {
            this.changeVideoState(video, 'pause');  
        }
    }

    /*
    ** Current state supported : "play", "pause", "blocked" (rgpd), "init" (after rgpd)
    */
    changeVideoState(video, state) {
        const iframe = video.querySelector('iframe');
        const button = video.querySelector('.filiale-video-play');

        iframe.contentWindow.postMessage(state, '*');
        video.dataset.state = state;

        // Hide the play button
        button.style.display = (state === 'play') ? 'none' : 'block';
    }

    initCanvas(canvas) {
        if (!canvas.getContext) {
            console.warn("Browser does not support canvas");
            return ;
        }

        let img = new Image();

        img.src = canvas.dataset.src;

        img.onload = () => this.drawImage(canvas, img);
    }

    drawImage(canvas, img) {
        const ctx = canvas.getContext('2d');
        const width = (window.innerWidth < this.breakpoint) ? 250 : 465;
        const height = (window.innerWidth < this.breakpoint) ? 195 : 366;
        canvas.width = width;
        canvas.height = height;
        const skewAngle = Math.atan(0.42);  // Angle must be in radian degree
        const skewWidth = skewAngle * height;
        const widthRatio = canvas.width / img.width;
        const heightRatio = canvas.height / img.height;
        const ratio = Math.max(widthRatio, heightRatio);
        const offsetX = (canvas.width - img.width * ratio) / 2;
        const offsetY = (canvas.height - img.height * ratio) / 2;

        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(width - skewWidth, 0);
        ctx.lineTo(width, height);
        ctx.lineTo(skewWidth, height);
        ctx.clip();
        ctx.drawImage(img, 0, 0, img.width, img.height,
            0, offsetY, img.width * ratio, img.height * ratio);
    }
}

export default Filiale;


// WEBPACK FOOTER //
// ./src/scripts/components/Filiale.js